import { useCallback, useState } from "react";

const MAIL_ID_PARAM = "emailid";

const readMailIdFromUrl = (): string | null =>
  new URLSearchParams(window.location.search).get(MAIL_ID_PARAM);

/**
 * The selected message lives in the ?emailid= query string, which engagement links already
 * use to open a specific email. It is replaced rather than pushed, so Back still leaves the tab.
 * The tab is mounted into a legacy page without a router, so the URL is updated directly.
 */
export const useSelectedMailId = () => {
  const [selectedMailId, setSelectedMailId] = useState<string | null>(readMailIdFromUrl);

  const select = useCallback((mailId: string | null) => {
    setSelectedMailId(mailId);

    const url = new URL(window.location.href);
    if (mailId) {
      url.searchParams.set(MAIL_ID_PARAM, mailId);
    } else {
      url.searchParams.delete(MAIL_ID_PARAM);
    }
    window.history.replaceState(window.history.state, "", url);
  }, []);

  return { selectedMailId, select };
};
